import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { getBaseUrl, REFERRALS_ENDPOINT } from '../../constants';

import { normalizeApplication, normalizeApplications, toReferralPayload } from '../normalizers';

export class Referrals {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Referrals(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = REFERRALS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllReferrals(req) {
    const queryString = queryBuilder(req);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: normalizeApplications(response?.data ?? []), meta: response?.meta };
  }

  async postReferral(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, toReferralPayload(reqBody));
    return normalizeApplication(response?.data);
  }
}

export const createReferrals = () => Referrals.getInstance();
